import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import FromFieldText from '../../atoms/FromFieldText';
import { getCompanyProfileList, getDatabaseSetupInfo, saveDbConfigure } from '../../services/user.service';
import * as CryptoJS from "crypto-js";

const TEXT_REGEX = /^[a-zA-Z0-9-_ ]{1,255}$/;

function DbConfigure() {
    const DB_NAME_PREFIX = "EcomFAT_";
    const DB_USER_PREFIX = "EcomFAT_User_";
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);

    const [companyId, setCompanyId] = useState('');
    const [ErrCompanyId, setErrCompanyId] = useState(false);

    const [databaseHost, setDatabaseHost] = useState('localhost');
    const [ErrDatabaseHost, setErrDatabaseHost] = useState(false);

    const [databasePort, setDatabasePort] = useState('3306');
    const [ErrDatabasePort, setErrDatabasePort] = useState(false);
    
    const [databaseName, setDatabaseName] = useState(DB_NAME_PREFIX);
    const [ErrDatabaseName, setErrDatabaseName] = useState(false);

    const [databaseUser, setDatabaseUser] = useState(DB_USER_PREFIX);
    const [ErrDatabaseUser, setErrDatabaseUser] = useState(false);

    const [databasePassword, setDatabasePassword] = useState('');
    const [ErrDatabasePassword, setErrDatabasePassword] = useState(false);
    const [setupStatus, setSetupStatus] = useState('');
    const [ErrSetupStatus, setErrSetupStatus] = useState(false);

    const [confirmPassword, setConfirmPassword] = useState('');
    const [ErrConfirmPassword, setErrConfirmPassword] = useState('');

    const [companies, setCompanies] = useState([]);

    

    const resetUserInfo = function () {
        setDatabaseHost('');
        setDatabasePort('');
        setDatabaseName('');
        setDatabaseUser('');
        setDatabasePassword('');
        
        setCompanyId('');
        
    }

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Configure_ID = query.get('configure_id');

    useEffect(() => {
        if (Configure_ID !== '' && Configure_ID != null) {
            const decryptedBytes = CryptoJS.AES.decrypt(Configure_ID.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
            const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
            const ConfigureID = decrypt_data.configure_id;
            getConfigureData(ConfigureID);
        }

        const EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        const oData = { 'token': EncryptData };
        
    }, []);
    useEffect(() => {
            // encrypted data
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                // 'param_data':obj,
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
    
            let oData = { 'token': EncryptData };
    
            getCompanyProfileList(oData)
                .then(res => {
                    if (res?.data?.data?.length) {
                        setCompanies(res.data.data);
                    }
                });
        }, []);
    
    const getConfigureData = function (ConfigureID) {
        const EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'configure_id': ConfigureID },
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

        const oData1 = { 'token': EncryptData };

        getDatabaseSetupInfo(oData1).then(function (res) {
            console.log(res?.data?.data);
            if (res?.data?.data?.length > 0) {
                const regInfo = res.data.data[0];
                setCompanyId(regInfo?.company_id || '');
                setDatabaseHost(regInfo?.db_host || '');
                setDatabasePort(regInfo?.db_port || '');
                setDatabaseUser((regInfo?.db_user || '').replace(DB_USER_PREFIX, ''));
                setDatabaseName((regInfo?.host_name || '').replace(DB_NAME_PREFIX, ''));
                setDatabasePassword(regInfo?.db_password || '');

                // Fetch companies for the selected continent
                
            } else {
                setErrMsg("Failed to fetch configure details.");
            }
        }).catch(() => {
            setErrMsg("Unable to fetch configure details. Please try again.");
        });
    };

    const handleCompanyId = (e) => {
        setCompanyId(e.target.value);
    }
    const handleSetupStatus = (e) => {
        setSetupStatus(e.target.value);
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        let valid_Name = true;

        if (!TEXT_REGEX.test(companyId)) {
            setErrCompanyId('Company name is required');
            valid_Name = false;
        } else {
            setErrCompanyId('');
        }

        if (!TEXT_REGEX.test(databaseHost)) {
            setErrDatabaseHost('Database host is required');
            valid_Name = false;
        } else {
            setErrDatabaseHost('');
        }
        if (!TEXT_REGEX.test(databaseName)) {
            setErrDatabasePort('Database port is required');
            valid_Name = false;
        } else {
            setErrDatabasePort('');
        }
        if (!TEXT_REGEX.test(databaseName)) {
            setErrDatabaseName('Database name is required');
            valid_Name = false;
        } else {
            setErrDatabaseName('');
        }
        if (!TEXT_REGEX.test(databaseUser)) {
            setErrDatabaseUser('Database user is required');
            valid_Name = false;
        } else {
            setErrDatabaseUser('');
        }
        /*if (!TEXT_REGEX.test(databasePassword)) {
            setErrDatabasePassword('Database password is required');
            valid_Name = false;
        } else {
            setErrDatabasePassword('');
        }*/

    // PASSWORD
    if (!databasePassword) {
        setErrDatabasePassword("Password is required");
        valid_Name = false;
    } else {
        setErrDatabasePassword('');
    }
    // CONFIRM PASSWORD
    if (!confirmPassword) {
        setErrConfirmPassword("Confirm password is required");
        valid_Name = false;
    } else if (confirmPassword !== databasePassword) {
        setErrConfirmPassword("Password & Confirm password must match");
        valid_Name = false;
    } else {
        setErrConfirmPassword('');
    }

        if (valid_Name) {
            saveData();
        }
    };
const generatePassword = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()";
    let pass = "";
    for (let i = 0; i < 12; i++) {
        pass += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setDatabasePassword(pass);
    setConfirmPassword(pass);
};
    
    const saveData = function () {
        try {
            const obj = Configure_ID
                ? {
                    'configure_id': JSON.parse(CryptoJS.AES.decrypt(Configure_ID.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString(CryptoJS.enc.Utf8)).configure_id,
                    'comp_db_name':  databaseName,
                    'comp_db_user':  databaseUser,
                    'comp_db_password': databasePassword,
                    'comp_host_name': databaseHost,
                    'comp_port': databasePort,
                    'comp_company_id': companyId,
                    'status': '1',
                    'created_by': sessionStorage.getItem('LoggedInUserId'),
                }: {
                    'comp_db_name': databaseName,
                    'comp_db_user': databaseUser,
                    'comp_db_password': databasePassword,
                    'comp_host_name': databaseHost,
                    'comp_port': databasePort,
                    'status': '1',
                    'created_by': sessionStorage.getItem('LoggedInUserId'),
                };

            const EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': obj,
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

            const oData = { 'token': EncryptData };

            saveDbConfigure(oData).then(function (res) {
                if (res?.data?.errors?.errno > 0) {
                    setErrMsg(res.data.message);
                    setSuccess(false);
                } else {
                    setSuccess(res.data.message);
                    resetUserInfo();
                }
            });
        } catch {
            setErrMsg('Insert/Update Failed');
        }
    };

    return (
        <div className="container">

            <div className="row">
                <div className="col-6">
                    <h5>Add Database Configure</h5>
                </div>
                <div className="invalid-feedback" role="alert">
                    <i className="fa fa-info-circle"></i>
                    Please Fill all mandatory field.
                </div>

                {success ? (
                    <div className="alert alert-success" role="alert"><i
                        className="bi bi-check-circle-fill"></i>{success}</div>
                ) : (errMsg ? (<div className="alert alert-danger" role="alert"><i
                        className="bi bi-exclamation-triangle-fill"></i>{errMsg}</div>) : ('')
                )}
            </div>

            <div className='row '>
                <div className='col-12'>&nbsp;</div>

            </div>

            <form onSubmit={handleSubmit}>
                
                <div className="row form-fields">
                    <div className="label col-3">
                        <label>Company</label><span className="star error"> *</span>
                    </div>
                    <div className="item col-3">
                        <select
                            className="form-select form-select-sm mb-3"
                            onChange={handleCompanyId}
                            value={companyId} // Bind value to state
                        >
                            <option value="">Select Company</option>
                            {companies.map((option) => (
                                <option key={option.company_id} value={option.company_id}>
                                    {option.company_name}
                                </option>
                            ))}
                        </select>
                        <span className="invalid-feedback"> {ErrCompanyId} </span>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-6">
                        <FromFieldText
                            star="*"
                            label="database host"
                            inputValue={databaseHost}
                            setInputValue={setDatabaseHost}
                            setErrorMsg={ErrDatabaseHost}
                        />
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-6">
                        <FromFieldText
                            star="*"
                            label="database port"
                            inputValue={databasePort}
                            setInputValue={setDatabasePort}
                            setErrorMsg={ErrDatabasePort}
                        />
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-6">
                        <FromFieldText
                            star="*"
                            label="database name"
                            inputValue={databaseName}
                            setInputValue={setDatabaseName}
                            setErrorMsg={ErrDatabaseName}
                        />
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-6">
                        <FromFieldText
                            star="*"
                            label="database user"
                            inputValue={databaseUser}
                            setInputValue={setDatabaseUser}
                            setErrorMsg={ErrDatabaseUser}
                        />
                    </div>
                </div>
                <div className="row mb-2">
    <div className="col-6">
        <FromFieldText
            star="*"
            label="Database Password"
            inputValue={databasePassword}
            setInputValue={setDatabasePassword}
            setErrorMsg={ErrDatabasePassword}
        />
    </div>
    <div className="col-2 d-flex align-items-end">
        <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={generatePassword}
        >
            Generate
        </button>
    </div>
</div>

<div className="row mb-2">
    <div className="col-6">
        <FromFieldText
            star="*"
            label="Confirm Password"
            inputValue={confirmPassword}
            setInputValue={setConfirmPassword}
            setErrorMsg={ErrConfirmPassword}
        />
    </div>
</div>

                <div className="row form-fields mt-2">
                    <div className="label col-3">
                        <label>Status </label><span className="star error"> *</span>
                    </div>

                    <div className="item col-3">
                        <select className="form-select form-select-sm mb-3" value={setupStatus}
                                onChange={handleSetupStatus}>
                            <option value="">Select Status</option>
                            <option value="1">Active</option>
                            <option value="2">Inactive</option>
                        </select>
                        <span className="invalid-feedback"> {ErrSetupStatus} </span>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-6">
                        <button className="btn btn-primary btn-sm" type="submit">Save</button>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default DbConfigure;
